<template>
  <main class="flex flex-column node-chat-main pb-3">
    <i class="close-btn" @click.prevent="toggleChat">
      <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"></path></svg>
    </i>
    <header class="title-bar flex flex-row flex-center" v-if="false">
      <div class="title-wrapper block center-element">
        <img class="logo" src="http://feathersjs.com/img/feathers-logo-wide.png"
             alt="Feathers Logo">
        <span class="title">Chat</span>
      </div>
    </header>

    <div class="flex flex-row flex-1 clear">
      <aside class="sidebar col col-4 flex flex-column flex-space-between">
        <header class="mb-3">
          <div class="flex flex-row flex-space-between mb-1">
            <input type="text" name="text" class="flex-1 form-control-sm"
                   placeholder="Поиск"
                   v-model="searchText">
            <button class="el-button" @click="searchText=''">Очистить</button>
          </div>
          <div class="flex flex-row mb-2">
            <label>
              <input type="checkbox"
                     :true-value="true"
                     :false-value="false"
                     v-model="searchUnread" /> Только непрочитанные
            </label>
          </div>
        </header>

        <ul class="flex flex-column flex-1 list-unstyled user-list p-0">
          <li v-for="(items, type) in messageTotals" :key="type" class="py-0">
                <a href="#" class="chat-type-group" @click.prevent="typeShowToggle(type)">
                  {{ translateType(type) }} ({{ calcCountNotModerated(items) }} / {{ calcCountTotal(items) }})
                </a>
                <ul v-if="expandedTypes.indexOf(type) >= 0 || searchText.length">
                  <template v-for="item in items" :key="item.typeId">
                    <node-chat-type-item :searchText="searchText" :searchUnread="searchUnread"
                                         :type="type"
                                         :item="item" />
                  </template>
                </ul>
          </li>
        </ul>
        <footer class="flex flex-row flex-center">
<!--          <a href="#" id="logout" class="button button-primary">-->
<!--            Sign Out-->
<!--          </a>-->
        </footer>
      </aside>

      <div class="flex flex-column col col-8">
        <main class="chat flex flex-column flex-1 clear">
          <template v-for="message in messages" :key="message.id">
            <node-chat-message :message="message" />
          </template>

        </main>

        <form class="flex flex-row flex-space-between" id="send-message"
              @submit.prevent="sendMessageText"
              v-if="nodeChatCurrentChatTypeId && nodeChatCurrentChatType">
          <input type="text" name="text" class="flex flex-1 form-control-sm"
                 placeholder="Комментарий"
                 v-model="messageText">
          <button class="el-button" type="submit" @click.prevent="sendMessageText">Отправить</button>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
import NodeChatMessage from './NodeChatMessage'
import NodeChatTypeItem from './NodeChatTypeItem'
import {feathersClient, messagesTypeService} from "../../feathers-client";
import {createNamespacedHelpers} from "vuex";
const { mapMutations, mapActions, mapGetters } = createNamespacedHelpers('nova')
export default {
  name: "NodeChatMain",
  props: ["messages", "messageTotals"],
  components: {
    'node-chat-message': NodeChatMessage,
    'node-chat-type-item': NodeChatTypeItem
  },
  data: () => ({
    expandedTypes: [],
    messageText: '',
    searchText: '',
    searchUnread: false,
  }),
  methods: {
    ...mapMutations(['toggleChat']),
    calcCountTotal(items){
      let sum = 0;
      items.forEach(item => {
        if(item.hasOwnProperty('module') && item.hasOwnProperty('countTotal') && item.countTotal){
          sum += item.countTotal
        }
      })

      return sum
    },
    calcCountNotModerated(items){
      let sum = 0;
      items.forEach(item => {
        if(item.hasOwnProperty('module') && item.hasOwnProperty('countNotModerated') && item.countNotModerated){
          sum += item.countNotModerated
        }
      })

      return sum
    },
    typeShowToggle(type){
      const index = this.expandedTypes.indexOf(type)
      if(index >= 0){
        this.expandedTypes.splice(index, 1)
      } else {
        this.expandedTypes.push(type)
      }
    },
    sendMessageText(){
      feathersClient.service(`messages/${this.nodeChatCurrentChatType}/${this.nodeChatCurrentChatTypeId}`)
          .create({
            text: this.messageText
          })
          .then(() => {
            this.messageText = ''
          })
    },
    translateType(type){
      switch (type){
        case 'article':
          return 'Статьи'
        case 'book':
          return 'Книги'
        case 'course':
          return 'Программы обучения'
        case 'exam':
          return 'Тесты'
        case 'scorm':
          return 'Скорм-курсы'
        case 'video':
          return 'Видео'
        case 'news':
          return 'Новости'
        case 'film':
          return 'Фильмы'
        case 'podcast':
          return 'Подкасты'
        default:
          return type
      }
    }
  },
  computed: {
    ...mapGetters([
        'nodeChatCurrentChatTypeId',
        'nodeChatCurrentChatType',
    ])
  }
}
</script>

<style scoped>

</style>
